var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35907 4.98531C4.9896 3.07759 7.68071 2.46957 9.97304 3.49097C10.4775 3.71575 11.0687 3.48901 11.2935 2.98454C11.5183 2.48007 11.2915 1.88889 10.787 1.66411C7.68566 0.282216 4.04473 1.10483 1.83872 3.68587C-0.367295 6.2669 -0.612894 9.99151 1.23511 12.8399C3.08311 15.6882 6.58449 16.9818 9.84048 16.0191C13.0965 15.0564 15.3314 12.0662 15.3334 8.67087V8.05087C15.3334 7.49859 14.8857 7.05087 14.3334 7.05087C13.7811 7.05087 13.3334 7.49859 13.3334 8.05087V8.67087C13.3317 11.1802 11.6798 13.3897 9.27341 14.1012C6.86681 14.8127 4.27883 13.8566 2.91292 11.7513C1.547 9.646 1.72853 6.89303 3.35907 4.98531Z",
    fill: "#4444C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7071 3.37788C16.0977 2.98736 16.0977 2.35419 15.7071 1.96367C15.3166 1.57315 14.6834 1.57315 14.2929 1.96367L7.66669 8.5899L6.37379 7.297C5.98327 6.90648 5.3501 6.90648 4.95958 7.297C4.56906 7.68753 4.56906 8.32069 4.95958 8.71122L6.95958 10.7112C7.3501 11.1017 7.98327 11.1017 8.37379 10.7112L15.7071 3.37788Z",
    fill: "#4444C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.397b41d757bd9fed067ff0dbb613c47f.svg";
export { ForwardRef as ReactComponent };